/**
 * 物件カテゴリー（URLハッシュ・API パス・ピンの data-type に使う値）
 * @type {Readonly<Record<string, string>>}
 */
export const CATEGORIES = {
    NEW_MANSION: "new_mansion", // 新築マンション
    USED_MANSION: "used_mansion", // 中古マンション
    HOUSE: "house", // 戸建て
    NEW_HOUSE: "new_house", // 新築戸建て
    USED_HOUSE: "used_house", // 中古戸建て
    LAND: "land", // 土地
    INVEST: "invest", // 事業用
};

/**
 * マップの初期設定（google.maps.Map のコンストラクタに渡すオプション）
 * デフォルトのコントロール類はすべて非表示にし、独自のツールボタンで操作する
 * 初期位置・ズームは MAP_VIEWS から site_mode に応じて選択する
 * @type {google.maps.MapOptions}
 */
export const MAP_DEFAULT_CONFIG = {
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    zoomControl: false,
    cameraControl: false, // 新しい API バージョンでズームの代わりに表示されるカメラコントロール
};

/**
 * サイトモードごとの初期表示位置
 * キーは config/site.php の areas と同じエリアキー（Blade が data-area で出力する）
 * default は総合版（東北6県全体を引きで表示）、各県は県庁所在地を中心に表示する
 * @type {Record<string, { center: { lat: number, lng: number }, zoom: number }>}
 */
export const MAP_VIEWS = {
    default: { center: { lat: 39.15, lng: 140.7 }, zoom: 7 }, // 東北6県全体
    aomori: { center: { lat: 40.8246, lng: 140.7406 }, zoom: 9 }, // 青森市
    iwate: { center: { lat: 39.7036, lng: 141.1527 }, zoom: 9 }, // 盛岡市
    miyagi: { center: { lat: 38.2682, lng: 140.8694 }, zoom: 9 }, // 仙台市
    akita: { center: { lat: 39.7186, lng: 140.1024 }, zoom: 9 }, // 秋田市
    yamagata: { center: { lat: 38.2554, lng: 140.3396 }, zoom: 9 }, // 山形市
    fukushima: { center: { lat: 37.7608, lng: 140.4748 }, zoom: 9 }, // 福島市
};

/**
 * 現在地表示時のズームレベル
 * 現在のズームがこれより引きのときだけ寄せる（すでに寄っているときはズームアウトさせない）
 * @type {number}
 */
export const CURRENT_LOCATION_ZOOM = 14;

/**
 * キーワード検索でヒットした地点へ移動するときのズームレベル
 * 検索結果に表示範囲(viewport)が無い場合のフォールバックとして使う
 * @type {number}
 */
export const KEYWORD_SEARCH_ZOOM = 15;

/**
 * キーワード検索の対象地域を絞るためのバイアス（東北6県の範囲）
 * 同名地名が全国にある場合に東北側の結果を優先させる
 * @type {{ south: number, west: number, north: number, east: number }}
 */
export const KEYWORD_SEARCH_BOUNDS = {
    south: 36.7,
    west: 139.1,
    north: 41.6,
    east: 142.1,
};

/**
 * 物件カードマーカーの z-index
 * ピンは zIndex 未指定時「画面の下にあるほど手前」に自動採番され、その値は 100 を超えることがある。
 * カードが常にピンより手前に来るよう、CSS z-index の上限値を指定する
 * @type {number}
 */
export const CARD_MARKER_Z_INDEX = 2147483647;

/**
 * 物件カードの最大表示数（検索ボタンの ids[] にもこの上限を適用する）
 * @type {number}
 */
export const MAX_DISPLAY = 20;
